import * as React from 'react';

import { Button } from 'semantic-ui-react';
import Registry from '../../../global/Registry';

interface Props {
	complete: boolean;
	value?: string;
	correct: boolean;
	onChange: (value: string) => void;
}

interface State {
	showInstructions: boolean;
}

export default class BooleanExerciseComponent extends React.Component<Props, State> {

	public constructor () {
		super();
		this.state = { showInstructions: false };
	}

	componentWillMount () {
		const KEY = 'numberOfBooleanExercisesSeen' + Registry.getInstance().me.getId().getValue();

		const numberOfBooleanExercisesSeen = localStorage.getItem(KEY) === null ? 0 : Number(localStorage.getItem(KEY));

		this.setState({ showInstructions: numberOfBooleanExercisesSeen < 3 });

		localStorage.setItem(KEY, String(numberOfBooleanExercisesSeen + 1));
	}

	renderInstruction () {
		return this.state.showInstructions ? <p className='exercise-instruction'>True or false?</p> : null;
	}

	render () {
		return (
			<div>
				{this.renderInstruction()}
				<div>{this.props.children}</div>
				<Button color={this.props.complete && this.props.value === 'true' ? (this.props.correct ? 'green' : 'red') : undefined} inverted style={{margin: '24px'}} onClick={() => this.props.onChange('true')}>True</Button>
				<Button color={this.props.complete && this.props.value === 'false' ? (this.props.correct ? 'green' : 'red') : undefined} inverted style={{margin: '24px'}} onClick={() => this.props.onChange('false')}>False</Button>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/exercises/BooleanExerciseComponent.tsx